import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./utils/msalConfig";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import AppProvider from "./contexts/AuthContext";
import "bootstrap-icons/font/bootstrap-icons.css";

// Ensure TypeScript knows about the root element, and handle possible null (in case it's not found)
const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  msalInstance.initialize();
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AppProvider>
          <App />
        </AppProvider>
      </MsalProvider>
    </React.StrictMode>
  );
} else {
  console.error("Root element not found!");
}
